import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Mes",
  "use": "icon-Mes-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Mes\"><defs><style type=\"text/css\"></style></defs><path d=\"M512.197376 0.001024a511.990528 511.990528 0 0 0-328.697919 904.687263L153.804006 1023.98208l193.53242-27.647488A511.990528 511.990528 0 1 0 512.197376 0.001024zM281.801638 409.593447h102.398106l-51.199053 204.796211h-102.398105z m255.995265 204.796211h-102.398106l51.199053-204.796211h102.398105z m204.796211 0h-102.398106l51.199053-204.796211h102.398106z\" p-id=\"12899\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Mes.svg
// module id = 7/2Y
// module chunks = 44